import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  jointInitiative: {
    id: 'portal.views.homePage.section.jointInitiative',
    defaultMessage: 'A joint initiative of <span>Legatum</span>, the Oxford Character Project '
      + 'at the <span>University of Oxford</span> and {lineBreak} the Human Flourishing Program '
      + 'at <span>Harvard\'s Institute for Quantitative Social Science</span>.',
    description: 'Homepage joint initiative text',
  },
  beBetterLeader: {
    id: 'portal.views.homePage.hero.heading.beBetterLeader',
    defaultMessage: 'Be a better leader {lineBreak} Build a better world',
    description: 'Homepage hero headline',
  },
  leadingWithCharacterIntro: {
    id: 'portal.views.homePage.section.intro',
    defaultMessage: 'Leading with Character is your guide to making a difference! '
      + 'Whether you are seeking to strengthen your local community, build a successful organisation, '
      + 'or address global challenges,  this course will help you to realise your potential as a leader.',
    description: 'Homepage intro paragraph',
  },
  getStarted: {
    id: 'portal.views.homePage.button.getStarted',
    defaultMessage: 'Get Started',
    description: 'Homepage get started button',
  },
  exploreTheCourse: {
    id: 'portal.views.homePage.heading.exploreTheCourse',
    defaultMessage: 'Explore the course',
    description: 'Homepage explore the course heading',
  },
  characterCourseDescription: {
    id: 'portal.views.homePage.section.characterCourseDescription',
    defaultMessage: 'Character is what sets the best leaders apart. Our 30-day course is based on '
      + 'cutting-edge research into character, leadership and human flourishing from two of the world’s '
      + 'leading educational institutions – the University of Oxford and Harvard University. '
      + 'This course will help you to develop character qualities to lead from where you are and build '
      + 'the personal habits that are at the heart of good leadership.',
    description: 'Homepage character course description',
  },
  quoteText: {
    id: 'portal.views.homePage.section.quoteText',
    defaultMessage: '“I would recommend this course to every person. It is a \'must\' for leadership improvement.”',
    description: 'Homepage quote text',
  },
  quoteAuthor: {
    id: 'portal.views.homePage.section.quoteAuthor',
    defaultMessage: 'Pablo Arreguín',
    description: 'Homepage quote author',
  },
  quotePosition: {
    id: 'portal.views.homePage.section.quotePosition',
    defaultMessage: 'Organisational leader in STEM education at Scienko México',
    description: 'Homepage quote position',
  },
  learningJourney: {
    id: 'portal.views.homePage.heading.learningJourney',
    defaultMessage: 'Learning Journey',
    description: 'Homepage learning journey heading',
  },
  learningJourneyIntro: {
    id: 'portal.views.homePage.section.learningJourneyIntro',
    defaultMessage: 'Developed by a team of leadership experts from around the world, our course '
      + 'is free and open to all. Learn and grow at your own pace, anytime, anywhere.',
    description: 'Homepage learning journey intro',
  },
  learningJourneyModules: {
    id: 'portal.views.homePage.section.learningJourneyModules',
    defaultMessage: 'Our course features four core modules - each module offers 2-3 hours of engaging '
      + 'online content, followed by five days of practical exercises that take just 20 minutes a day.',
    description: 'Homepage learning journey modules',
  },
  globalReach: {
    id: 'portal.views.homePage.heading.globalReach',
    defaultMessage: 'Global Reach',
    description: 'Homepage global reach heading',
  },
  globalReachDescription: {
    id: 'portal.views.homePage.section.globalReachDescription',
    defaultMessage: 'Leaders around the world are prioritising their character development. '
      + 'Larger circles indicate higher numbers of leaders accessing the course from each location.',
    description: 'Homepage global reach description',
  },
  videoNotSupported: {
    id: 'portal.views.homePage.label.videoNotSupported',
    defaultMessage: 'Your browser does not support the video tag.',
    description: 'Video not supported fallback text',
  },
  globalReachIframeTitle: {
    id: 'portal.views.homePage.iframe.globalReachTitle',
    defaultMessage: 'Global reach map',
    description: 'Title for the global reach map iframe',
  },
});

export default messages;
